module.exports = __webpack_public_path__ + "static/coworker4-563a4720f7998ffe89196dddfdc17d9f.png";